/** @typedef {typeof DEFAULT_OPTIONS} CleanupOptions */

export const STORAGE_KEY = 'vorakit_text_cleaner_v1';
export const PRESET_KEY = 'vorakit_text_cleaner_preset_v1';

/** @type {CleanupOptions} */
export const DEFAULT_OPTIONS = {
  removeExtraSpaces: true,
  trimLines: true,
  collapseBlankLines: true,
  maxConsecutiveBlankLines: 1,
  mergeBrokenLines: true,
  preserveParagraphs: true,
  preserveLists: true,
  flattenToOneLine: false,
  normalizeQuotes: true,
  removeInvisibleChars: true,
  normalizeDashes: true,
  removeDuplicateLines: false,
  tabsToSpaces: true,
  tabWidth: 2,
  normalizeWhitespace: true,
  trailingSpaces: true,
  keepOriginalLineBreaks: false,
  smartCleanup: true,
};

/** @param {CleanupOptions} o */
export function cloneOptions(o) {
  return { ...o };
}

/** @type {Record<string, Partial<CleanupOptions>>} */
export const PRESETS = {
  smart: {
    removeExtraSpaces: true,
    trimLines: true,
    collapseBlankLines: true,
    maxConsecutiveBlankLines: 1,
    mergeBrokenLines: true,
    preserveParagraphs: true,
    preserveLists: true,
    flattenToOneLine: false,
    normalizeQuotes: true,
    removeInvisibleChars: true,
    normalizeDashes: true,
    removeDuplicateLines: false,
    tabsToSpaces: true,
    normalizeWhitespace: true,
    trailingSpaces: true,
    keepOriginalLineBreaks: false,
    smartCleanup: true,
  },
  pdf: {
    removeExtraSpaces: true,
    trimLines: true,
    collapseBlankLines: true,
    maxConsecutiveBlankLines: 1,
    mergeBrokenLines: true,
    preserveParagraphs: true,
    preserveLists: true,
    flattenToOneLine: false,
    normalizeQuotes: true,
    removeInvisibleChars: true,
    normalizeDashes: true,
    removeDuplicateLines: false,
    tabsToSpaces: true,
    normalizeWhitespace: true,
    trailingSpaces: true,
    keepOriginalLineBreaks: false,
    smartCleanup: false,
  },
  email: {
    removeExtraSpaces: true,
    trimLines: true,
    collapseBlankLines: true,
    maxConsecutiveBlankLines: 2,
    mergeBrokenLines: false,
    preserveParagraphs: true,
    preserveLists: true,
    flattenToOneLine: false,
    normalizeQuotes: true,
    removeInvisibleChars: true,
    normalizeDashes: false,
    removeDuplicateLines: false,
    tabsToSpaces: true,
    normalizeWhitespace: true,
    trailingSpaces: true,
    keepOriginalLineBreaks: false,
    smartCleanup: false,
  },
  plain: {
    removeExtraSpaces: true,
    trimLines: true,
    collapseBlankLines: true,
    maxConsecutiveBlankLines: 1,
    mergeBrokenLines: false,
    preserveParagraphs: false,
    preserveLists: false,
    flattenToOneLine: false,
    normalizeQuotes: true,
    removeInvisibleChars: true,
    normalizeDashes: true,
    removeDuplicateLines: false,
    tabsToSpaces: true,
    normalizeWhitespace: true,
    trailingSpaces: true,
    keepOriginalLineBreaks: false,
    smartCleanup: false,
  },
  oneLine: {
    removeExtraSpaces: true,
    trimLines: true,
    collapseBlankLines: true,
    maxConsecutiveBlankLines: 1,
    mergeBrokenLines: false,
    preserveParagraphs: false,
    preserveLists: false,
    flattenToOneLine: true,
    normalizeQuotes: true,
    removeInvisibleChars: true,
    normalizeDashes: false,
    removeDuplicateLines: false,
    tabsToSpaces: true,
    normalizeWhitespace: true,
    trailingSpaces: true,
    keepOriginalLineBreaks: false,
    smartCleanup: false,
  },
  preserve: {
    removeExtraSpaces: false,
    trimLines: false,
    collapseBlankLines: true,
    maxConsecutiveBlankLines: 2,
    mergeBrokenLines: false,
    preserveParagraphs: true,
    preserveLists: true,
    flattenToOneLine: false,
    normalizeQuotes: false,
    removeInvisibleChars: true,
    normalizeDashes: false,
    removeDuplicateLines: false,
    tabsToSpaces: false,
    normalizeWhitespace: true,
    trailingSpaces: false,
    keepOriginalLineBreaks: true,
    smartCleanup: false,
  },
};

/**
 * @param {string} presetId
 * @returns {CleanupOptions}
 */
export function optionsFromPreset(presetId) {
  const patch = PRESETS[presetId];
  if (!patch) return cloneOptions(DEFAULT_OPTIONS);
  return { ...DEFAULT_OPTIONS, ...patch };
}
